/** Valores do select de status das listagens: Todos, Ativos e Inativos. */
export type StatusFilter = 'all' | 'active' | 'inactive';

/**
 * Converte o select de status no campo `active` dos filtros do company-api.
 * `undefined` não filtra, e a listagem traz ativos e inativos.
 */
export function statusFilterToActive(status: StatusFilter): boolean | undefined {
  if (status === 'active') return true;
  if (status === 'inactive') return false;
  return undefined;
}
